/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { FieldError } from "react-hook-form";
import { When } from "react-if";
import { CSSObject } from "styled-components";
import { theme, Text } from "@nordcloud/gnui";
import { isNotEmpty, isNotNil } from "~/tools";

type Props = {
  children: JSX.Element | JSX.Element[];
  error?: FieldError | FieldError[];
  customCss?: CSSObject;
};

export function FormGroup({ children, error, customCss = {} }: Props) {
  const errors = (Array.isArray(error) ? error : [error]).filter(isNotNil);
  const hasErrors = isNotEmpty(errors);

  return (
    <div
      css={[
        { width: "100%", marginBottom: theme.spacing.spacing04 },
        customCss,
      ]}
    >
      {React.Children.map(children, (element) => {
        return React.cloneElement(element, {
          ...element.props,
          ...(element.props.id != null && hasErrors && { status: "danger" }),
        });
      })}
      <When condition={hasErrors}>
        {errors.map((e, index) => (
          <ErrorMessage key={`${e.message}-${index}`} text={e.message ?? ""} />
        ))}
      </When>
    </div>
  );
}

function ErrorMessage({ text }: { text: string }) {
  return (
    <Text mt={theme.spacing.spacing01} color="danger">
      {text}
    </Text>
  );
}
